import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import Component from "./Node.vue";
import { createDefaultBlockForTipTap } from "~/stores/mail-block-editor/defaults";

const Signature = Node.create({
    name: "signature",
    group: "block",
    content: "paragraph+",

    defining: true,

    addAttributes() {
        return createDefaultBlockForTipTap("signature");
    },

    parseHTML() {
        return [
            {
                tag: `signature`,
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [`signature`, mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(Component);
    },
});

export default Signature;
